import dayjs from "dayjs";
import { useEffect, useState } from "react";
import HomeCards from "../Components/Cards/HomeCards";
import HomeDiagram from "../Components/HomeComponents/Charts/HomeDiagram";
import DashboardPieCharts from "../Components/HomeComponents/Charts/DashboardPieCharts";
import LineDataset from "../Components/HomeComponents/Charts/LineDataset";
import config from "../config";
import "../Style/HomePage.css";
import { authFetch } from "../utils/Security/authFetch";
import localforage from "localforage";

type UserData = {
  name: string;
  age: number;
  country: string;
};

const rowData: UserData[] = [];

const handleImpactSelect = (item: any) => {
  //console.log("Selected Impact:", item);
};

function HomePage() {
  const [openIncidentCount, setOpenIncidentCount] = useState<number | null>(
    null,
  );
  const [allIncidents, setAllIncidents] = useState<number | null>(null);
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const userId = localStorage.getItem("userid");
  const isForTelebras = localStorage.getItem("isForTelebras") === "true";
  const isForPetrobras = localStorage.getItem("isForPetrobras") === "true";
  const isForNilesat = localStorage.getItem("isForNilesat") === "true";

  const INCIDENT_CACHE_KEY = `incidents_${isAdmin ? "admin" : userId}`;
  const [darkMode, setDarkMode] = useState<boolean>(
    () => localStorage.getItem("darkMode") === "true",
  );
  useEffect(() => {
    document.body.classList.toggle("dark-mode", darkMode);
    localStorage.setItem("darkMode", String(darkMode));
  }, [darkMode]);
  // useEffect(() => {
  //   localforage.removeItem(INCIDENT_CACHE_KEY);
  //   Promise.all([
  //     authFetch(
  //       `${config.apiBaseUrl}/api/incidents/count-open-this-month`
  //     ).then((res: any) => res.json()),
  //     authFetch(`${config.apiBaseUrl}/api/incidents/countallincidents`).then(
  //       (res: any) => res.json()
  //     ),
  //   ])
  //     .then(([openData, allIncidents]) => {
  //       setOpenIncidentCount(openData);
  //       setAllIncidents(allIncidents);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching incident data:", error);
  //     });
  // }, []);

  const currentMonthYear = dayjs().format("MMMM YYYY");
  return (
    <div className="dashboard">
      <div className="dashboard-header"></div>

      <div className="dashboard-grid">
        <div className="dashboard-row">
          {isAdmin ? (
            <>
              <div className="dashboard-left">
                <HomeCards />
              </div>
              <div className="dashboard-right">
                <LineDataset />
                <HomeDiagram />
                <div className="side-charts">
                  {isAdmin && !isForTelebras && !isForPetrobras && !isForNilesat &&  <DashboardPieCharts />}
                </div>{" "}
              </div>
            </>
          ) : (
            <div className="dashboard-full">
              <LineDataset />
              <HomeDiagram />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HomePage;
